import { render, staticRenderFns } from "./pointOfSale.vue?vue&type=template&id=0c378d46"
import script from "./pointOfSale.vue?vue&type=script&setup=true&lang=js"
export * from "./pointOfSale.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports